// hooks/useNotify.ts
import { useDispatch, useSelector } from "react-redux";
import { NotificationType } from "@/slides/notification/types";
import {
  hideNotification,
  showNotification,
} from "@/slides/notification/notificationSlice";
import { RootState } from "@/stores/rootReducer";

interface NotifyParams {
  title: string;
  message: string;
  type: NotificationType;
}

export const useNotify = () => {
  const dispatch = useDispatch();
  const current = useSelector((state: RootState) => state.notification);

  const show = ({ title, message, type }: NotifyParams) => {
    dispatch(showNotification({ title, message, type }));
  };

  const hide = () => {
    dispatch(hideNotification());
  };

  return { show, hide, current };
};
